<!--
 * @Autor: dc
 * @Date: 2022-03-24 15:58:47
 * @LastEditors: dc
 * @LastEditTime: 2022-03-24 16:42:19
 * @Description: 
-->
<template>
  <div id="app">
    <router-view/>
    
  </div>
  
</template>

<script>
export default {
  name: 'App'
}
</script>

<style >

#app {


   
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
 .wrapper{margin-top: 200px!important;}
 .el-message{top:46%!important;}
 .el-message p{font-size:16px!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue